module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-summary"
  }, [(false && _vm.showSummary && _vm.$utils.isCartOfflineShippable() && _vm.$utils.isCartShippable()) ? _c('div', [_c('div', {
    staticClass: "form__item--inline"
  }, [_c('div', {
    staticClass: "form__item--inline"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_c('input', {
    staticClass: "form__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": !_vm.$utils.isOfflineShipping()
    },
    on: {
      "change": function($event) {
        return _vm.$utils.setOfflineShipping(!$event.target.checked)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("ต้องการให้จัดส่ง")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__item--inline"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_c('input', {
    staticClass: "form__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.$utils.isOfflineShipping()
    },
    on: {
      "change": function($event) {
        return _vm.$utils.setOfflineShipping($event.target.checked)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("ต้องการรับของเอง")])])])]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.$utils.isCartEmpty()) ? _c('div', {
    staticClass: "product-cart"
  }, [_vm._l((_vm.cart), function(item) {
    return _c('div', {
      staticClass: "product-list product-cart__item"
    }, [_c('product-list-item', {
      key: _vm.sku(item),
      attrs: {
        "product": item.product,
        "initialChoices": item.attributes,
        "initialQuantity": item.quantity,
        "cart-mode": true,
        "show-attributes": false
      },
      on: {
        "itemRemoved": _vm.itemRemoved,
        "quantityChanged": _vm.updateQuantity
      }
    })], 1)
  }), _vm._v(" "), (_vm.showSummary) ? _c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "summary__row"
  }, [_c('div', {
    staticClass: "summary__label"
  }, [_vm._v("จำนวนรายการ (" + _vm._s(_vm.$utils.getCartItemCount()) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "summary__value"
  }, [_vm._v(_vm._s(_vm._f("comma")(_vm.$utils.getCartTotalPrice())) + " ฿")])]), _vm._v(" "), _vm._l((_vm.reducedShippingGroup), function(fee, group) {
    return (!_vm.$utils.isOfflineShipping()) ? _c('div', {
      staticClass: "summary__row"
    }, [_c('div', {
      staticClass: "summary__label"
    }, [_vm._v(_vm._s(group))]), _vm._v(" "), _c('div', {
      staticClass: "summary__value"
    }, [_vm._v(_vm._s(fee) + "  ฿")])]) : _vm._e()
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "summary__row"
  }, [_c('div', {
    staticClass: "summary__label"
  }, [_vm._v("ค่าจัดส่งทั้งหมด")]), _vm._v(" "), _c('div', {
    staticClass: "summary__value"
  }, [_vm._v(_vm._s(_vm._f("comma")(_vm.$utils.getCartShippingFee())) + " ฿")])]), _vm._v(" "), _c('div', {
    staticClass: "summary__row summary__row--total"
  }, [_c('div', {
    staticClass: "summary__label"
  }, [_vm._v("รวม")]), _vm._v(" "), _c('div', {
    staticClass: "summary__value"
  }, [_vm._v(_vm._s(_vm._f("comma")(_vm.$utils.getCartGrandTotalPrice())) + " ฿")])])], 2) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6ad97f6d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ad97f6d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartSummary.vue
// module id = 740
// module chunks = 1